import { MessageCircle } from "lucide-react";
import { whatsappLink, scrollToId, WHATSAPP_NUMBER } from "../config/site";
import { useLang } from "../config/i18n";

const PHONE_DISPLAY = `+${WHATSAPP_NUMBER.slice(0, 2)} ${WHATSAPP_NUMBER.slice(2, 4)} ${WHATSAPP_NUMBER.slice(4, 9)}-${WHATSAPP_NUMBER.slice(9)}`;

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="footer-section" className="relative pt-16 pb-8 border-t border-[#22222B] bg-[#0D0D10]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid gap-12 sm:grid-cols-3">
          <div>
            <img
              src="/selo-mestre-jonas.png"
              alt="Selo Mestre Jonas Barcellos"
              className="w-16 h-16 rounded-full object-cover border border-[#C5A059]/40 mb-5"
            />
            <p className="font-heading text-base tracking-[0.22em] text-[#F7F7F8] mb-2">MESTRE JONAS BARCELLOS</p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#C5A059] mb-1.5">
              {t.footer.tagline1}
            </p>
            <p className="text-[11px] tracking-[0.15em] uppercase text-[#6E6E7D]">
              {t.footer.tagline2}
            </p>
          </div>

          <div>
            <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.footer.navTitle}</p>
            <nav data-testid="footer-nav-links" className="flex flex-col gap-3">
              {t.navLinks.map(([label, id]) => (
                <button
                  key={id}
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-left text-sm text-[#A3A3AF] hover:text-[#D9A94A] transition-colors font-light"
                >
                  {label}
                </button>
              ))}
              <a
                data-testid="footer-link-whatsapp"
                href={whatsappLink(t.waDefault)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[#D9A94A] hover:text-[#E9BE62] transition-colors"
              >
                WhatsApp
              </a>
              <a
                data-testid="footer-link-goetia"
                href="/goetia"
                className="text-sm text-[#A3A3AF] hover:text-[#D9A94A] transition-colors font-light"
              >
                Enciclopédia da Goétia
              </a>
            </nav>
          </div>

          <div>
            <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.footer.contactTitle}</p>
            <p className="text-sm text-[#A3A3AF] font-light mb-4">
              {t.footer.contactText}
            </p>
            <a
              data-testid="footer-phone-link"
              href={whatsappLink(t.waDefault)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 text-sm text-[#D9A94A] hover:text-[#E9BE62] transition-colors"
            >
              <MessageCircle size={16} strokeWidth={1.6} /> {PHONE_DISPLAY}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#22222B] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#6E6E7D] font-light">
            {t.footer.rights}
          </p>
          <div className="flex gap-7">
            <button
              data-testid="footer-link-aviso"
              onClick={() => scrollToId("aviso")}
              className="text-[11px] tracking-[0.15em] uppercase text-[#6E6E7D] hover:text-[#C5A059] transition-colors"
            >
              {t.footer.aviso}
            </button>
            <button
              data-testid="footer-link-contato-cta"
              onClick={() => scrollToId("contato")}
              className="text-[11px] tracking-[0.15em] uppercase text-[#6E6E7D] hover:text-[#C5A059] transition-colors"
            >
              {t.footer.contato}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
